import { SVGProps } from 'react';

export function PsychosocialReportSVG(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.6906 6.7401L12.6529 6.44316C12.4741 5.03451 11.8026 3.74087 10.7637 2.80368C9.72484 1.86649 8.38963 1.34978 7.00725 1.35C5.93463 1.34989 4.88347 1.6612 3.97551 2.24806C3.06755 2.83492 2.33942 3.67345 1.87498 4.66703C1.41055 5.66062 1.22874 6.76883 1.35048 7.86397C1.4722 8.95891 1.8924 9.99623 2.5627 10.8565C3.42788 11.9645 3.94178 13.2602 3.94178 14.6754V16.65H9.19697L9.19785 13.95H12.2618C12.3779 13.95 12.4893 13.9026 12.5714 13.8182C12.6536 13.7338 12.6997 13.6193 12.6997 13.5V9.97216L14.2646 9.28423L12.6906 6.7401ZM15.7291 10.1088L14.0134 10.863V13.5C14.0134 13.9774 13.8289 14.4352 13.5004 14.7728C13.1719 15.1104 12.7264 15.3 12.2618 15.3H10.5111L10.5102 18H2.62809V14.6754C2.62809 13.6134 2.24624 12.6081 1.53772 11.7009C0.712464 10.642 0.195115 9.36507 0.0452788 8.0172C-0.104558 6.66933 0.119218 5.30538 0.690824 4.0825C1.26243 2.85963 2.1586 1.82759 3.27609 1.1053C4.39358 0.383014 5.6869 -0.000135968 7.00705 8.56993e-08C8.70844 -0.000269537 10.3518 0.635676 11.6304 1.78914C12.909 2.94261 13.7355 4.53478 13.9556 6.2685L15.9261 9.4536C16.0557 9.6633 16.0295 9.9756 15.7291 10.1088Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7 4.25C7.41421 4.25 7.75 4.58579 7.75 5V9C7.75 9.41421 7.41421 9.75 7 9.75C6.58579 9.75 6.25 9.41421 6.25 9V5C6.25 4.58579 6.58579 4.25 7 4.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.25 7C4.25 6.58579 4.58579 6.25 5 6.25H9C9.41421 6.25 9.75 6.58579 9.75 7C9.75 7.41421 9.41421 7.75 9 7.75H5C4.58579 7.75 4.25 7.41421 4.25 7Z"
				fill="currentColor"
			/>
		</svg>
	);
}
